// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".adAgreement .van-steps--horizontal .van-steps__items{margin-bottom:0}.adAgreement .van-field__label{flex:1;text-align:left;font-weight:600}.adAgreement .van-cell__value{flex:2}.adAgreement .van-field__control{border-bottom:1px solid #000;text-indent:10px}.adAgreement .van-field__control:disabled{color:#000}", ""]);
// Exports
module.exports = exports;
